import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { User, Settings, Moon, Sun, Twitter } from 'lucide-react'
import { useStore } from '../../store/useStore'

const Navbar = () => {
  const location = useLocation()
  const { theme, setTheme } = useStore()

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-dark-900/95 backdrop-blur-md border-b border-dark-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center space-x-2"
            >
              <div className="w-8 h-8 bg-lunatic-gradient rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">L</span>
              </div>
              <span className="text-xl font-bold gradient-text">Lunatics</span>
              <span className="text-sm text-dark-400">Social</span>
            </motion.div>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            {[
              { path: '/', label: 'Dashboard' },
              { path: '/leaderboard', label: 'Leaderboard' },
              { path: '/community', label: 'Community' },
            ].map(({ path, label }) => (
              <Link
                key={path}
                to={path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === path
                    ? 'text-lunatic-400 bg-lunatic-500/10'
                    : 'text-dark-300 hover:text-white hover:bg-dark-800'
                }`}
              >
                {label}
              </Link>
            ))}
          </div>

          {/* Right Side Actions */}
          <div className="flex items-center space-x-4">
            {/* Theme Toggle */}
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg bg-dark-800 hover:bg-dark-700 transition-colors"
            >
              {theme === 'dark' ? (
                <Sun className="w-5 h-5 text-yellow-400" />
              ) : (
                <Moon className="w-5 h-5 text-lunatic-400" />
              )}
            </button>

            {/* Twitter Link */}
            <a
              href="https://twitter.com/LunaticsBTC"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-lg bg-dark-800 hover:bg-dark-700 transition-colors"
            >
              <Twitter className="w-5 h-5 text-primary-400" />
            </a>

            {/* Profile */}
            <Link
              to="/profile"
              className="p-2 rounded-lg bg-dark-800 hover:bg-dark-700 transition-colors"
            >
              <User className="w-5 h-5 text-lunatic-400" />
            </Link>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar 